// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","StoryBoxPlaceholder":"StoryBoxPlaceholder-32ms4ek81372grgpmtmsj64y3ya3pthej3s993reud9zagwjt846cfs7sajaqrrybqk7p8z3jvkddu3696ckpns2114d9yqynq4qery","Year":"Year-2bgnc7kybkzr92jt9r8gnxvwef2szenedt7nv48kfxznq6zkvzb6tmbxtrxzyatptnv8pagzy485d1p4vzhq71tn4t4t8j9q3m97yxc","loading":"loading-3n4tmevuzj6u5nz1mwt3f8kthaqeq2c74swqe5hr7h3gfrneru2zbxn93mpqnrdq9z1tjgs3tatb56xjtd3fwen5kruq59b6c5a8ajj","pulse":"pulse-3g1havft66krepjgrsthvajcutcnhf2jmw23t7y74u7e1fhs1kh18agcv27u5v9t1fxp5ns22f2fc3nn3m17u1mjn5n4etwtmhbmnqf"};


//////////////////
// WEBPACK FOOTER
// ./src/views/History/placeholder/StoryBox/StoryBoxPlaceholder.module.scss
// module id = 1652
// module chunks = 0